import React, { Suspense } from 'react';
import Loader from './components/loader/Loader';

const ApplicationRoutes = React.lazy(() => import('./config/appRoute'));
export default function App() {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <ApplicationRoutes />
      </Suspense>
    </>
  );
}
